import React, { useEffect } from 'react'
import "./sidebar.css"
import { FaUsers, FaUser } from "react-icons/fa";
import { RiWifiOffLine } from "react-icons/ri";
import { BsHouseFill, BsArrowLeftCircle, BsArrowRightCircle } from "react-icons/bs";
import { Link } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from "react-i18next"

const Sidebar = () => {

    const { t } = useTranslation()

    const {
        showGroupOverview,
        setShowGroupOverview,
        toggleNav,
        setToggleNav,
        getGroups,
        groups,
        groupId,
        showGroupDropDown,
        handleGroupOverviewToggle,
        toggler
    } = useAuth()

    useEffect(() => {
        getGroups()
    }, [toggler])

    return (
        <nav id="sidebar" className={`${toggleNav ? 'active' : null} d-flex flex-column`}>
            <Link to="/" className='text-decoration-none'>
                <div role="button" className="sidebar-header ">
                    <h5 className='fw-bold text-center'>
                        {toggleNav ?
                            <BsHouseFill fontSize="1em" />
                            : null}
                        <span className='CTAs'>{t("Home.1")}</span> </h5>
                </div>
            </Link>
            <ul className="list-unstyled m-0">
                <li className='active ' >
                    <Link role="button" to="/group-overview" onClick={() => setShowGroupOverview(!showGroupOverview)} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle text-decoration-none text-center py-3" style={{ backgroundColor: "#ffe987", color: "#29235c" }}>
                        {toggleNav ?
                            <FaUsers className='' fontSize="2em" />
                            : null}
                        <h5 className="CTAs ml-2 fw-bold">
                            {t("Groups Overview.1")}
                        </h5>
                    </Link>
                    {
                        showGroupOverview && groups.map((group) => {
                            return (
                                <ul key={group.id} className="list-unstyled component">
                                    <li className="active">
                                        <a role="button" onClick={() => handleGroupOverviewToggle(group.id)} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle text-center text-decoration-none">
                                            <FaUser className='mx-1' fontSize="1.2em" />
                                            <span className="CTAs fw-bold">
                                                {group.group_name}
                                            </span>
                                        </a>
                                        {
                                            showGroupDropDown && groupId === group.id && <ul className="collapse list-unstyled show">
                                                <li className="first">
                                                    <div className="d-flex">
                                                        <div className="w-25 text-center my-auto">
                                                            <img alt="" src={require("src/images/results-first-survey1-icon.png")} style={{ transform: "translate(10px)" }} width="30" />
                                                        </div>
                                                        <div className="w-75  text-start CTAs" style={{ transform: "translate(-20px)" }} >
                                                            <Link to={`/result-first-survey/${group.code}`} className='text-decoration-none text-white' href="company.html" >{t("Results first survey.1")}</Link>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="first">

                                                    <div className="d-flex">
                                                        <div className="w-25 text-center my-auto" >
                                                            <img alt="" src={require("src/images/detailed-survey-1-icon.png")} width="30" style={{ transform: "translate(10px)" }} />
                                                        </div>
                                                        <div className="w-75  text-start CTAs" style={{ transform: "translate(-20px)" }}>
                                                            <Link to={`/detailed-first-survey/${group.code}`} className='text-decoration-none text-white' href="page.html">{t("Detailed survey answers.1")}</Link>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="first">

                                                    <div className="d-flex">
                                                        <div className="w-25 text-center my-auto">
                                                            <img alt="" src={require("src/images/results-first-survey2-icon.png")} width="30" style={{ transform: "translate(10px)" }} />
                                                        </div>
                                                        <div className="w-75  text-start CTAs" style={{ transform: "translate(-20px)" }}>
                                                            <Link to={`/result-second-survey/${group.code}`} className='text-decoration-none text-white'>{t("Results second survey.1")}</Link>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="first">
                                                    <div className="d-flex">
                                                        <div className="w-25 text-center my-auto">
                                                            <img alt="" src={require("src/images/detailed-survey-2-icon.png")} width="30" style={{ transform: "translate(10px)" }} />
                                                        </div>
                                                        <div className="w-75 text-start  CTAs" style={{ transform: "translate(-20px)" }}>
                                                            <Link to={`/detailed-second-survey/${group.code}`} className='text-decoration-none text-white'>{t("Detailed survey answers.1")}</Link>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="first ">
                                                    <div className="d-flex">
                                                        <div className="w-25  text-center my-auto">
                                                            <img alt="" src={require("src/images/comparison-first-icon.png")} width="30" style={{ transform: "translate(10px)" }} />
                                                        </div>
                                                        <div className="w-75 CTAs text-start" style={{ transform: "translate(-20px)" }}>
                                                            <Link to={`/comparison-first-and-final/${group.code}`} className='text-decoration-none text-white'>{t("Comparison first and final survey.1")}</Link>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        }
                                    </li>
                                </ul>
                            )
                        })
                    }
                </li>
            </ul>
            <Link to="/offline-impact-assessment" className='text-decoration-none'>
                <div role="button" className="sidebar-header ">
                    <h5 className='fw-bold text-center'>
                        {toggleNav ?
                            <RiWifiOffLine fontSize="1em" />
                            : null}
                        <span className='CTAs'>{t("Offline Impact Assessment.1")}</span> </h5>
                </div>
            </Link>
            <div onClick={() => setToggleNav(!toggleNav)} role="button" className='mt-auto p-3' id="sidebarCollapse">
                <div role="button">
                    {
                        !toggleNav ?
                            <h5 className='fw-bold text-center'>
                                <BsArrowLeftCircle fontSize="1.5em" />
                                &nbsp;
                                Hide
                            </h5>
                            :
                            <h5 className='fw-bold text-center'>
                                <BsArrowRightCircle fontSize="1.5em" />
                            </h5>
                    }
                </div>
            </div>
        </nav >
    )
}

export default Sidebar